export default __webpack_public_path__ + "static/bg-pattern-light-43b4c0ea545f90a048a31aa88e997208.png";